import { useMutation, useQuery } from 'react-query';

import { httpClient } from 'app/api/http/http-client';
import { TransactionsRequestType } from 'app/utils/services/types/transactions.type';

const transactionsService = {
    getTransactions: async (): Promise<any> => {
    const result = await httpClient.post<any>('/api-web/v1/main/get-transactions');

    return result;
  },

  filterChangesTransactions: async (data: TransactionsRequestType): Promise<TransactionsRequestType> => {
    const result = await httpClient.post<any>('/api-web/v1/main/get-transactions', data);

    return result;
  },

  sendTransferOtp: async (data: any): Promise<any> => {
    const result = await httpClient.post<any>(
      `/api-web/v1/main/transfer-details?business_key=${data.businessKey}`,
      data.data
    );

    return result;
  },

  getTransferDetails: async (data: any): Promise<any> => {
    return await httpClient.post<any>('/api-web/v1/main/transfer-details', data);
  },
};

export const useTransactionsService = () => {
  const {
    isLoading: isLoadingTransactions,
    data: dataTransactions,
    refetch: refetchTransactions,
  } = useQuery(['transactions'], transactionsService.getTransactions);

  return { isLoadingTransactions, dataTransactions, refetchTransactions };
};

export const useFilterChangeTransactions = () => {
  const {
    isLoading: isLoadingFilterTransactions,
    isSuccess: isSuccessFilterTransactions,
    data: dataFilterTransactions,
    mutate: filterTransactionMutation,
  } = useMutation(['filterTransactions'], (data: TransactionsRequestType) =>
    transactionsService.filterChangesTransactions(data)
  );

  return {
    isLoadingFilterTransactions,
    isSuccessFilterTransactions,
    filterTransactionMutation,
    dataFilterTransactions,
  };
};

export const useGetTransferDetails = () => {
  const {
    isSuccess: isSuccessGetTransferDetails,
    isLoading: isLoadingGetTransferDetails,
    data: dataGetTransferDetails,
    mutate: getTransferDetailsMutation,
    variables : transferDetailsMutationVariables,

  } = useMutation(['transferDetails'], (data: any) => transactionsService.getTransferDetails(data));

  return {
    isSuccessGetTransferDetails,
    isLoadingGetTransferDetails,
    dataGetTransferDetails,
    getTransferDetailsMutation,
    transferDetailsMutationVariables
  };
};

export const useSendTransferOtp = () => {
  const {
    isSuccess: isSuccessSendTransferOtp,
    isLoading: isLoadingSendTransferOtp,
    data: dataSendTransferOtp,
    mutate: sendTransferOtpMutation,
  } = useMutation(['sendTransferOtp'], (data: any) => transactionsService.sendTransferOtp(data));

  return {
    isSuccessSendTransferOtp,
    isLoadingSendTransferOtp,
    dataSendTransferOtp,
    sendTransferOtpMutation,
  };
};
